<template>
  <div class="propertycontrol">
    <div class="header">
      <div class="title">移动综合管控</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="right">
        <div class="position">
          <img :src="mobilepropertyoffice2" alt="" />
        </div>
      </div>

      <div class="left">
        后台智能数据统计，一键分析，针对人员管理、流程审批、待办事项等事宜在线进行综合管控，提高物业管理能力。
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilepropertyoffice2 from "../../../../assets/product/mobilepropertyoffice2.png";

export default {
  setup() {
    return reactive({
      mobilepropertyoffice2:mobilepropertyoffice2
    });
  },
};
</script>

<style scoped>
.propertycontrol {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
}
.body .right .logo img {
  width: 332px;
}
.body .right .position img {
  width: 238px;
}
.body .right .position img:nth-of-type(1) {
  right: 100%;
}
.body .right .position img:nth-of-type(2) {
  right: 125%;
  bottom: 0;
}
.body .right .position img:nth-of-type(3) {
  right: 150%;
  bottom: 0;
}
.body .left {
  width: 92vw;
  margin: 16px auto 0;
  font-size: 12px;
  color: #3d3d3d;
}
</style>
